export const TAB_ALL_RESULT = 'Todos los resultados';
export const TAB_PROGRAM = 'Programas';
export const TAB_COURSE = 'Cursos';
export const TAB_DIRECT_ACCESS = 'Accesos directos';